import { Empty } from "antd";
import React from "react";

const Td = ({ children, colspan, className, align_middle = true }) => (
  <td
    className={`${align_middle ? "align-middle" : ""} ${className || ""}`}
    colSpan={colspan || 1}
  >
    {children || ""}
  </td>
);
const Tr = ({ children, className, style }) => (
  <tr className={className || "align-middle tableColumn"} style={style || {}}>
    {children}
  </tr>
);

function TableUi({
  children,
  ths,
  ths_expanded,
  className,
  hoverable = true,
  total,
  responsive = false
}) {
  return (
    <table
      className={`table table-sm ${hoverable ? "table-hover" : ""} ${responsive ? "table-responsive" : ""} ${
        className || "mt-3"
      }`}
    >
      <thead>
        <tr className="text-muted tableColumn">
          {ths_expanded ? (
            <>
              {ths_expanded.map((th, idx) => (
                <th
                  className={
                    th.className ||
                    `text-black align-middle ${
                      idx == 0
                        ? "p-left"
                        : idx == ths_expanded.lenght - 1
                        ? "p-right"
                        : ""
                    }`
                  }
                  key={idx}
                  style={th.style || {}}
                >
                  {th.label}
                </th>
              ))}
            </>
          ) : (
            ths.map((title, idx) => (
              <th
                className={`text-black align-middle ${
                  idx == 0 ? "p-left" : idx == ths.lenght - 1 ? "p-right" : ""
                }`}
                key={idx}
              >
                {title}
              </th>
            ))
          )}
        </tr>
      </thead>
      <tbody>
        {total == 0 ? <RenderEmpty total_ths={ths.length} /> : children}
      </tbody>
    </table>
  );
}

const RenderEmpty = ({ total_ths }) => {
  return (
    <Tr>
      <Td colspan={total_ths}>
        <div className={"d-flex align-items-center justify-content-center"}>
          <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
        </div>
      </Td>
    </Tr>
  );
};
TableUi.td = Td;
TableUi.tr = Tr;
export default TableUi;
